import React, { useEffect } from 'react';

export const useEffectOnMount = (cb: React.EffectCallback) => useEffect(cb, []);
